import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { putMessage, reset } from './actions';
import { SystemStateMessage } from '../../../models/SystemStateMessage';

export interface SystemStateMessageState {
  message: SystemStateMessage;
}

const initialState: SystemStateMessageState = {
  message: new SystemStateMessage()
};

const reducer = reducerWithInitialState(initialState)
  .case(putMessage, (state, payload) => {
    return { message: { ...payload } };
  })
  .case(reset, (state, payload) => {
    return { ...initialState };
  })
;

export default reducer;




// WEBPACK FOOTER //
// ./src/redux/modules/systemStateMessage/reducers.ts